
{
  "fr": {
    "ConfiguratorEditorThemePickerModal": {
      "title": "Choisir un visuel",
      "subTitle": "Sélectionnez un visuel pour voir le rendu",
      "confirm-action": "Valider ce visuel"
    }
  }
}
